var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"bg","cx":"16","cy":"16","r":"16","fill":"#F0F0F0","key":0}),React.createElement("path",{"id":"fill","d":"M20.0075 16.9995L20.452 14.104H17.6735V12.225C17.6735 11.433 18.0615 10.6605 19.306 10.6605H20.569V8.1955C20.569 8.1955 19.423 8 18.327 8C16.039 8 14.5435 9.387 14.5435 11.8975V14.1045H12V17H14.5435V24H17.6735V17L20.0075 16.9995Z","fill":"currentColor","key":1})]);
}

Facebook.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
